const config = {
  defaultRatio: 4,
  imageRatio: 1.8,
  sidebarWidth: 320,
  defaultCanvasWidth: 1400,
  defaultCanvasHeight: 800,
  // defaultCanvasGap: 40,
  defaultCanvasGap: 0,
  defaultTileGap: 70,
  defaultRotation: 90,
  maxX: 0,
  maxY: 0,
  canvasSpace: 30,
  debounceTime: 400,
  defaultMounting: "underlimmad",
  defaultThickness: '30mm'
};
export default config;
